import React from "react";

const InputPixelsHeight = (props) => {
    const {store} = props;

    console.log("rendering InputPixelsHeight ", store.getState().pixelHeight)

    return (
        <>
            <input type="number"
                   className="form-control"
                   id="pixels_height_input"
                   name="pixels_height_input"
                   value={store.getState().pixelHeight}
                   onInput={e => store.dispatch({type: 'CHANGE_PIXEL_HEIGHT', data: e.target.value})}
            />
        </>
    )
}

export default InputPixelsHeight
